import { useState } from 'react';
import { signIn, startSSOLogin } from '../lib/auth-service';

interface SignInProps {
  onSuccess: () => void;
}

export function SignIn({ onSuccess }: SignInProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showEmail, setShowEmail] = useState(false);

  async function handleSignIn(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signIn(email, password);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #002D43 0%, #001a2e 50%, #000000 100%)',
    }}>
      <div style={{
        width: 400,
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '48px 40px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/peregrine_black.png" alt="Peregrine" style={{ height: 56, marginBottom: 16 }} />
          <div style={{ fontSize: 28, fontWeight: 700, color: '#002D43', letterSpacing: '-0.5px' }}>
            Peregrine
          </div>
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4 }}>
            g/d/n/a internal operations
          </div>
        </div>

        <button
          onClick={startSSOLogin}
          style={{
            width: '100%',
            padding: '12px 0',
            background: '#002D43',
            color: '#FFFFFF',
            border: 'none',
            borderRadius: 8,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 24,
            transition: 'background 0.15s',
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = '#003d5c')}
          onMouseOut={(e) => (e.currentTarget.style.background = '#002D43')}
        >
          Sign in with SSO
        </button>

        {!showEmail ? (
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => setShowEmail(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#6B7280',
                fontSize: 13,
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              or sign in with email
            </button>
          </div>
        ) : (
          <form onSubmit={handleSignIn}>
            <div style={{
              borderTop: '1px solid #E5E7EB',
              paddingTop: 20,
              marginTop: 4,
            }}>
              {error && (
                <div style={{
                  background: '#FEF2F2',
                  border: '1px solid #FECACA',
                  borderRadius: 6,
                  padding: '10px 14px',
                  fontSize: 13,
                  color: '#DC2626',
                  marginBottom: 16,
                }}>
                  {error}
                </div>
              )}

              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@gdna.ai"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #D1D5DB',
                  borderRadius: 6,
                  fontSize: 14,
                  outline: 'none',
                  boxSizing: 'border-box',
                  marginBottom: 14,
                }}
              />

              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #D1D5DB',
                  borderRadius: 6,
                  fontSize: 14,
                  outline: 'none',
                  boxSizing: 'border-box',
                  marginBottom: 20,
                }}
              />

              <button
                type="submit"
                disabled={!email || !password || loading}
                style={{
                  width: '100%',
                  padding: '11px 0',
                  background: email && password ? '#002D43' : '#D1D5DB',
                  color: email && password ? '#FFFFFF' : '#9CA3AF',
                  border: 'none',
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: email && password ? 'pointer' : 'not-allowed',
                  transition: 'background 0.15s',
                }}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </div>
          </form>
        )}

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: '#9CA3AF' }}>
          Peregrine · GDNA AI · {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
